
import React, { useCallback, useEffect, useState } from "react";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat"; // load on demand
import { DatePicker } from "antd";
import locale from "antd/es/date-picker/locale/en_US";
import type { CountdownProps } from 'antd';
import { Col, Row, Statistic } from 'antd';
import { signUp } from "../../app/api";
import { AxiosError } from "axios";
import { Link } from "react-router-dom";

dayjs.extend(customParseFormat);

const letters = [
    "А",
    "Б",
    "В",
    "Г",
    "Д",
    "Е",
    "Ё",
    "Ж",
    "З",
    "И",
    "Й",
    "К",
    "Л",
    "М",
    "Н",
    "О",
    "Ө",
    "П",
    "Р",
    "С",
    "Т",
    "У",
    "Ү",
    "Ф",
    "Х",
    "Ц",
    "Ч",
    "Ш",
    "Щ",
    "Ъ",
    "Ь",
    "Ы",
    "Э",
    "Ю",
    "Я",
];

export default function RegisterForm() {
    const [agree, setAgree] = useState(false);
    const [preview, setPreview] = useState<null | string>(null);
    
    const [registerLoading, setRegisterLoading] = useState(false);
    const [userCreated, setUserCreated] = useState(false);
    const [serverError, setServerError] = useState('');

    const { Countdown } = Statistic;
    const deadline = Date.now() + 1000 * 60 * 5; // Dayjs is also OK

    const [userBio, setUserBio] = useState({
        lastName: "",
        firstName: "",
        register_letter_1: "А",
        register_letter_2: "А",
        register_number: "",
        gender: "эрэгтэй",
        birthDate: dayjs().format("YYYY-MM-DD"),
        address: "",
        school: "",
        grade: "",
        parentPhone: "",
        email: "",
        phone: "",
        password: "",
        password_confirmation: "",
        image: undefined,
    });

    const fieldsName = [
       { key: 'lastName', name: 'Овог' },
         { key: 'firstName', name: 'Нэр' },
         { key: 'registerNumber', name: 'Регистрийн дугаар' },
         {key: 'gender', name: 'Хүйс'},
            {key: 'birthDate', name: 'Төрсөн он, сар, өдөр'},
            {key: 'phone', name: 'Хэрэглэгчийн нэвтрэх утасны дугаар'},
            {key: 'email', name: 'Имэйл'},
            {key: 'parentPhone', name: 'Эцэг эхийн утасны дугаар'},
            {key: 'address', name: 'Гэрийн хаяг'},
            {key: 'school', name: 'Сургууль'},
            {key: 'grade', name: 'Анги'},
            {key: 'password', name: 'Нууц үг'},
            {key: 'password_confirmation', name: 'Нууц үгээ давтана уу'},
    ]

    const [errors, setErrors] = useState<string[]>([]);

    const handleRegister = useCallback(async () => {
        setUserCreated(false);
        setServerError('');

        setRegisterLoading(true);
        const curErrors: string[] = [];

        Object.entries(userBio).forEach(([key, value]) => {
            if(!value) {
                curErrors.push(key);
            }
        });
        if(!agree) {
            curErrors.push('agree');
        }
        if(userBio.register_number.length !== 8) {
            curErrors.push('register_number');
        }

        setErrors(curErrors);
        if(curErrors.length === 0) {
            const formData = new FormData();
            Object.entries(userBio).forEach(([key, value]) => {
                if(value) {
                    formData.append(key, value);
                }
            });
            let registerNumber = userBio.register_letter_1 + userBio.register_letter_2 + userBio.register_number;
            formData.append('registerNumber', registerNumber);

            try {
                const resp = await signUp(formData);
                if(resp.status == 200) {
                    setUserBio({
                        lastName: "",
                        firstName: "",
                        register_letter_1: "A",
                        register_letter_2: "A",
                        register_number: "",
                        gender: "эрэгтэй",
                        birthDate: dayjs().format("YYYY-MM-DD"),
                        address: "",
                        school: "",
                        grade: "",
                        parentPhone: "",
                        email: "",
                        phone: "",
                        password: "",
                        password_confirmation: "",
                        image: undefined,
                    });

                    setUserCreated(true);
                }
            } catch(err) {
                const {response} = (err as AxiosError);

                setServerError(`Алдаа: ${JSON.stringify(response?.data)}`);
            }
        }
        setRegisterLoading(false);
    }, [userBio, agree]);

    return (
        <main className={`bg-white`}>
            <div className="mx-auto max-w-7xl p-10 pt-[96px] flex flex-col justify-center ">
                <h1 className="pt-12 text-3xl text-[#001447] sm:text-3xl italic mb-5 font-bold">
                    Бүртгүүлэх хэсэг
                </h1>
                <p className="text-[#001447] ">
                    Та дээрх хугацаанаас өмнө бүртгэл үүсгэснээр эрхийн бичиг захиалах
                    боломжтой болно.
                    <br className="hidden lg:block" />
                    Бүртгэлийн мэдээлэл сольж болохгүй тул, мэдээллийг{" "}
                    <strong>үнэн зөв</strong> бөглөнө үү.
                </p>
                <form>
                    <div className="grid pt-12 lg:grid-flow-col gap-4">
                     
                        <div className="lg:col-span-2">
                            <div className="flex gap-6 flex-row">
                                <label className="basis-1/2 mb-4">
                                    <span className="text-gray-700">Овог</span>
                                    <input
                                        required
                                        value={userBio.lastName}
                                        type="text"
                                        className="mt-1 block text-[#001447] w-full rounded-2xl border-[#001447]/20  disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none"
                                        placeholder="Хүүхдийн овог"
                                        onChange={(e) =>
                                            setUserBio({ ...userBio, lastName: e.target.value })
                                        }
                                        
                                    />
                                    {errors.includes("lastName") && (
                                        <p className="mt-2 text-red-500 text-xs italic">
                                            Овог оруулна уу
                                        </p>
                                    )}
                                </label>
                                <label className="basis-1/2 mb-4">
                                    <span className="text-gray-700">Нэр</span>
                                    <input
                                        required
                                        value={userBio.firstName}
                                        type="text"
                                        className="mt-1 block text-[#001447] w-full rounded-2xl border-[#001447]/20  disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none"
                                        placeholder="Хүүхдийн нэр"
                                        onChange={(e) =>
                                            setUserBio({ ...userBio, firstName: e.target.value })
                                        }
                                        
                                    />
                                    {errors.includes("firstName") && (
                                        <p className="mt-2 text-red-500 text-xs italic">
                                            Нэр оруулна уу
                                        </p>
                                    )}
                                </label>
                            </div>
                            <div className="lg:flex gap-6 flex-row mt-4">
                                <label className="basis-1/2">
                                    <span className="text-gray-700">*Регистрийн дугаар</span>
                                    <div className="flex gap-4 mb-4">
                                        <select
                                            value={userBio.register_letter_1}
                                            onChange={(e) => {
                                                setUserBio({
                                                    ...userBio,
                                                    register_letter_1: e.target.value,
                                                });
                                            }}
                                            className="block basis-1/5 w-full mt-1 rounded-2xl border-[#001447]/20 text-[#001447]"
                                            
                                        >
                                            {letters.map((l, index) => {
                                                return (
                                                    <option value={l} key={index}>
                                                        {l}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                        <select
                                            value={userBio.register_letter_2}
                                            onChange={(e) => {
                                                setUserBio({
                                                    ...userBio,
                                                    register_letter_2: e.target.value,
                                                });
                                            }}
                                            className="block basis-1/5 w-full mt-1 rounded-2xl border-[#001447]/20 text-[#001447]"
                                            
                                        >
                                            {letters.map((l, index) => {
                                                return (
                                                    <option value={l} key={index}>
                                                        {l}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                        <input
                                            required
                                            value={userBio.register_number}
                                            type="tel"
                                            className="mt-1 basis-3/5 block text-[#001447] w-full rounded-2xl border-[#001447]/20  disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none"
                                            placeholder="Регистрийн дугаар"
                                            maxLength={8}
                                            minLength={8}
                                            onChange={(e) =>
                                                setUserBio({
                                                    ...userBio,
                                                    register_number: e.target.value
                                                        .replace(/[^0-9.]/g, "")
                                                        .replace(/(\..*)\./g, "$1"),
                                                })
                                            }
                                            
                                        />
                                    </div>
                                    {["register_letter_1", "register_letter_2", "register_number"].reduce((prev, v) => errors.includes(v) || prev, false) && (
                                        <p className="mt-2 text-red-500 text-xs italic">
                                            Регистрийн дугаар оруулна уу
                                        </p>
                                    )}
                                </label>
                                <div className="flex mt-7 mb-7">
                                    <input
                                        id="link-checkbox"
                                        type="checkbox"
                                        checked={agree}
                                        onChange={e => {setAgree(e.target.checked)}}
                                        className="mt-1 w-4 h-4 text-blue-600 bg-white border-gray-300 rounded focus:ring-blue-500 focus:ring-2  disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none"
                                    />
                                    <label
                                        htmlFor="link-checkbox"
                                        className="ml-2 text-sm font-medium text-[#001447]/60"
                                    >
                                        Регистрийн дугаарыг цогцолборын мэдээллийн санд хадгалахыг
                                        зөвшөөрч байна.
                                        {errors.includes("agree") && (
                                            <p className="mt-2 text-red-500 text-xs italic">
                                                Дээрхт нөхцөлийг хүлээн зөвшөөрнө үү
                                            </p>
                                        )}
                                    </label>
                                </div>

                                {/* <label className="basis-1/2">
                  <span className="text-gray-700">*Төрсөн он, сар, өдөр</span>
                  <div className="flex gap-4 mb-4">
                    <input
                      required
                      value={userBio.birthYear}
                      type="tel"
                      className="mt-1 basis-3/5 block text-[#001447] w-full rounded-2xl border-[#001447]/20  disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none"
                      placeholder="Төрсөн он"
                      maxLength={4}
                      minLength={4}
                      onChange={(e) =>
                        setUserBio({
                          ...userBio,
                          birthYear: e.target.value
                            .replace(/[^0-9.]/g, "")
                            .replace(/(\..*)\./g, "$1"),
                        })
                      }
                      
                    />
                    <input
                      required
                      value={userBio.birthMonth}
                      type="tel"
                      className="mt-1 basis-1/5 block text-[#001447] w-full rounded-2xl border-[#001447]/20  disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none"
                      placeholder="cар"
                      maxLength={2}
                      minLength={2}
                      onChange={(e) =>
                        setUserBio({
                          ...userBio,
                          birthMonth: e.target.value
                            .replace(/[^0-9.]/g, "")
                            .replace(/(\..*)\./g, "$1"),
                        })
                      }
                      
                    />
                    <input
                      required
                      value={userBio.birthDay}
                      type="tel"
                      className="mt-1 basis-1/5 block text-[#001447] w-full rounded-2xl border-[#001447]/20  disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none"
                      placeholder="өдөр"
                      maxLength={2}
                      minLength={2}
                      onChange={(e) =>
                        setUserBio({
                          ...userBio,
                          birthDay: e.target.value
                            .replace(/[^0-9.]/g, "")
                            .replace(/(\..*)\./g, "$1"),
                        })
                      }
                      
                    />
                  </div>
                  {errors.includes("birthDay") && (
                    <p className="mt-2 text-red-500 text-xs italic">
                      Төрсөн өдөр оруулна уу
                    </p>
                  )}
                  {errors.includes("birthDay-invalid") && (
                    <p className="mt-2 text-red-500 text-xs italic">
                      Төрсөн өдөр зөв оруулна уу
                    </p>
                  )}
                </label> */}
                            </div>
                            <div className="grid grid-cols-2 gap-4">
                                <label className="col-span-2 md:col-span-1 mb-4 flex flex-col">
                                    <span className="text-gray-700">Хүйс</span>
                                    <select
                                        value={userBio.gender}
                                        className="block basis-1/5 w-full mt-1 rounded-2xl border-[#001447]/20 text-[#001447] disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none"
                                        onChange={(e) => setUserBio({
                                            ...userBio,
                                            gender: e.target.value as string,
                                        })}
                                    >
                                        {["эрэгтэй", "эмэгтэй"].map((gender) => {
                                            return (
                                                <option value={gender} key={gender}>
                                                    {gender}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </label>
                                <label className="col-span-2 md:col-span-1 mb-4">
                                    <span className="text-gray-700">*Төрсөн он, сар, өдөр</span>
                                    <div className="flex gap-4 mb-4 mt-1">
                                        {userBio.birthDate && (
                                            <DatePicker
                                                locale={locale}
                                                defaultValue={dayjs(userBio.birthDate, "YYYY-MM-DD")}
                                                style={{
                                                    borderRadius: 14,
                                                    height: 40,
                                                    borderColor: "#00144720",
                                                    backgroundColor: "#fff",
                                                }}
                                                className="w-full"
                                                onChange={(_, dateString) => setUserBio({
                                                    ...userBio,
                                                    birthDate: (dateString as string) ||  "",
                                                })}
                                            />
                                        )}
                                    </div>
                                </label>
                            </div>
                            <label className="block mt-4 pb-4">
                                <span className="text-gray-700">*Хэрэглэгчийн нэвтрэх утасны дугаар</span>
                                <input
                                    value={userBio.phone}
                                    type="tel"
                                    className="mt-1 block w-full rounded-2xl border-[#001447]/20 text-[#001447]  disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none"
                                    placeholder="Утасны дугаар"
                                    maxLength={8}
                                    minLength={8}
                                    onChange={(e) =>
                                        setUserBio({
                                            ...userBio,
                                            phone: e.target.value
                                                .replace(/[^0-9.]/g, "")
                                                .replace(/(\..*)\./g, "$1"),
                                        })
                                    }
                                    
                                />
                                {errors.includes("phone") && (
                                    <p className="mt-2 text-red-500 text-xs italic">
                                        Утасны дугаар оруулна уу
                                    </p>
                                )}
                            </label>
                            <label className="block mt-4 pb-4">
                                <span className="text-gray-700">Имэйл</span>
                                <input
                                    value={userBio.email}
                                    type="email"
                                    className="mt-1 block w-full rounded-2xl border-[#001447]/20 text-[#001447]  disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none"
                                    placeholder="Имэйл"
                                    maxLength={256}
                                    onChange={(e) =>
                                        setUserBio({
                                            ...userBio,
                                            email: e.target.value
                                        })
                                    }
                                    
                                />
                                {errors.includes("email") && (
                                    <p className="mt-2 text-red-500 text-xs italic">
                                        Имэйл оруулна уу
                                    </p>
                                )}
                            </label>
                            <label className="block mt-4 pb-4">
                                <span className="text-gray-700">Эцэг эхийн утасны дугаар</span>
                                <input
                                    value={userBio.parentPhone}
                                    type="tel"
                                    className="mt-1 block w-full rounded-2xl border-[#001447]/20 text-[#001447]  disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none"
                                    placeholder="Утасны дугаар"
                                    maxLength={8}
                                    minLength={8}
                                    onChange={(e) =>
                                        setUserBio({
                                            ...userBio,
                                            parentPhone: e.target.value
                                                .replace(/[^0-9.]/g, "")
                                                .replace(/(\..*)\./g, "$1"),
                                        })
                                    }
                                    
                                />
                                {errors.includes("parentPhone") && (
                                    <p className="mt-2 text-red-500 text-xs italic">
                                        Утасны дугаар оруулна уу
                                    </p>
                                )}
                            </label>
                            <label className="block mt-4 pb-4">
                                <span className="text-gray-700">Гэрийн хаяг</span>
                                <input
                                    value={userBio.address}
                                    onChange={(e) =>
                                        setUserBio({
                                            ...userBio,
                                            address: e.target.value,
                                        })
                                    }
                                    type="text"
                                    className="mt-1 block w-full rounded-2xl border-[#001447]/20 text-[#001447]  disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none"
                                    placeholder="Гэрийн хаяг"
                                    
                                />
                                {errors.includes("address") && (
                                    <p className="mt-2 text-red-500 text-xs italic">
                                        Гэрийн хаяг оруулна уу
                                    </p>
                                )}
                            </label>
                            <div className="flex gap-6 flex-row mt-4 pb-4">
                                <label className="basis-1/2">
                                    <span className="text-gray-700">Сургууль</span>
                                    <input
                                        value={userBio.school}
                                        onChange={(e) =>
                                            setUserBio({
                                                ...userBio,
                                                school: e.target.value,
                                            })
                                        }
                                        type="text"
                                        className="mt-1 block text-[#001447] w-full rounded-2xl border-[#001447]/20  disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none"
                                        placeholder="Сургууль"
                                        
                                    />
                                    {errors.includes("school") && (
                                        <p className="mt-2 text-red-500 text-xs italic">
                                            Сургууль оруулна уу
                                        </p>
                                    )}
                                </label>
                                <label className="basis-1/2">
                                    <span className="text-gray-700">Анги</span>
                                    <input
                                        value={userBio.grade}
                                        onChange={(e) =>
                                            setUserBio({
                                                ...userBio,
                                                grade: e.target.value,
                                            })
                                        }
                                        type="text"
                                        className="mt-1 block text-[#001447] w-full rounded-2xl border-[#001447]/20  disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none"
                                        placeholder="Анги"
                                    />
                                    {errors.includes("grade") && (
                                        <p className="mt-2 text-red-500 text-xs italic">
                                            Анги оруулна уу
                                        </p>
                                    )}
                                </label>
                            </div>

                            <label className="block mt-4 pb-4">
                                <span className="text-gray-700">Хүүхдийн зураг</span>
                                <div className="flex items-center justify-center w-full mt-5">
                                    <label
                                        htmlFor="dropzone-file"
                                        className="flex flex-col items-center justify-center w-full h-64 border-2 border-[#384EB7]/30 border-dashed rounded-lg cursor-pointer bg-[#F8F8F8]"
                                    >
                                        {!userBio.image ? (
                                            <div className="flex flex-col items-center justify-center pt-5 pb-6">
                                                <svg
                                                    className="w-10 h-10 mb-3 text-gray-400"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    viewBox="0 0 24 24"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth="2"
                                                        d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                                                    ></path>
                                                </svg>
                                                <p className="mb-2 text-sm text-[#0F0F0F]">
                                                    Drag & drop files or{" "}
                                                    <span className="font-semibold text-[#483EA8] underline">
                                                        Browse
                                                    </span>
                                                </p>
                                                <p className="text-xs text-[#676767]">
                                                    Supported formates: PNG, JPG (MAX.
                                                    800x400px)
                                                </p>
                                            </div>
                                        ) : (
                                            preview && (
                                                <img
                                                    src={preview}
                                                    width={100}
                                                    height={100}
                                                    alt="image"
                                                ></img>
                                            )
                                        )}
                                        <input
                                            id="dropzone-file"
                                            type="file"
                                            accept="image/*"
                                            className="hidden"
                                            value={''}
                                            onChange={async (e) => {
                                                if(e.target.files) {
                                                    const img = e.target.files[0];
                                                    setUserBio({
                                                        ...userBio, 
                                                        // @ts-ignore
                                                        image: img,
                                                    });

                                                    // convert file to a base64 url
                                                    const readURL = (file: File) => {
                                                        return new Promise((res, rej) => {
                                                            const reader = new FileReader();
                                                            reader.onload = e => {
                                                                if(e.target) {
                                                                    res(e.target.result);
                                                                } else {
                                                                    res('');
                                                                }
                                                            };
                                                            reader.onerror = e => rej(e);
                                                            reader.readAsDataURL(file);
                                                        });
                                                    };
                                                    const previewUrl = (await readURL(img) as string);
                                                    setPreview(previewUrl);
                                                }
                                            }}
                                        />
                                        {errors.includes("image") && (
                                            <p className="mt-2 text-red-500 text-xs italic">
                                                Зураг оруулна уу
                                            </p>
                                        )}
                                    </label>
                                </div>
                            </label>

                            <div className="flex gap-6 flex-row mt-4 pb-4">
                            <label className="basis-1/2 mb-4">
                                    <span className="text-gray-700">
                                        *Нууц үг (4 оронтой пин код)
                                    </span>
                                    <input
                                        required
                                        value={userBio.password}
                                        type="password"
                                        className="mt-1 block text-[#001447] w-full rounded-2xl border-[#001447]/20  disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none"
                                        placeholder="****"
                                        maxLength={4}
                                        minLength={4}
                                        onChange={(e) =>
                                            setUserBio({
                                                ...userBio,
                                                password: e.target.value
                                                    .replace(/[^0-9.]/g, "")
                                                    .replace(/(\..*)\./g, "$1"),
                                            })
                                        }
                                        
                                    />
                                    {errors.includes("password") && (
                                        <p className="mt-2 text-red-500 text-xs italic">
                                            Нууц үг (4 оронтой пин код) оруулна уу
                                        </p>
                                    )}
                                </label>
                                <label className="basis-1/2 mb-4">
                                    <span className="text-gray-700">*Нууц үгээ давтана уу</span>
                                    <input
                                        required
                                        value={userBio.password_confirmation}
                                        type="password"
                                        className="mt-1 block text-[#001447] w-full rounded-2xl border-[#001447]/20  disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none"
                                        placeholder="****"
                                        maxLength={4}
                                        minLength={4}
                                        onChange={(e) =>
                                            setUserBio({
                                                ...userBio,
                                                password_confirmation: e.target.value
                                                    .replace(/[^0-9.]/g, "")
                                                    .replace(/(\..*)\./g, "$1"),
                                            })
                                        }
                                        
                                    />
                                    {errors.includes("password_confirmation") && (
                                        <p className="mt-2 text-red-500 text-xs italic">
                                            Нууц үг (4 оронтой пин код) давтан оруулна уу
                                        </p>
                                    )}
                                </label>
                            </div>

                        </div>
                    </div>
                    {userCreated ?
                        <div
                            className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mt-5"
                            role="alert"
                        >
                            <Link to={'/login'}>
                                <a className="block sm:inline">Бүртгэл амжилттай. Энд дарж нэвтэрнэ үү.</a>
                            </Link>
                        </div>
                        : !registerLoading ?
                            <div className="flex flex-1 items-center justify-center gap-x-6 mt-4 mb-6">
                                <button
                                    type="submit"
                                    onClick={(e) => {e.preventDefault(); handleRegister()}}
                                    className={`rounded-full bg-[#07B2EC] px-8 py-2 text-sm font-semibold text-white`}
                                >
                                    
                                    Бүртгүүлэх
                                </button>
                            </div>
                            :
                            <div className="flex flex-1 items-center justify-center gap-x-6 mt-4 mb-6">
                                <button
                                    disabled
                                    className={`rounded-full bg-gray-200 px-8 py-2 text-sm font-semibold text-black`}
                                >
                                    Илгээж байна.
                                </button>
                            </div>

                    }
                    {serverError && (
                        <div
                            className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mt-5"
                            role="alert"
                        >
                            
                            <span className="block sm:inline">{serverError}</span>
                        </div>
                    )}

                </form>
            </div>
        </main>
    );
}